import {
  getTreeNodeChildren,
  getTreeNodeDescription,
  getTreeNodeId,
  type TreeNode,
  type TreeNodeList,
} from './treeNode'

export default function searchTree(tree: TreeNodeList, searchValue: string) {
  if (!searchValue.trim()) return []
  const searchLower = searchValue.toLowerCase().trim()
  const result: string[] = []
  const queue: TreeNode[] = [...tree]

  while (queue.length > 0) {
    const node = queue.shift()!

    if (getTreeNodeDescription(node).toLowerCase().includes(searchLower)) {
      result.push(getTreeNodeId(node))
    }

    queue.push(...getTreeNodeChildren(node))
  }

  return result
}
